<script setup lang="ts">
  import { ref } from 'vue';
  import { useI18n } from '@/common/composables/vue-i18n.composable';

  const { t } = useI18n();

  const visible = ref(false);

  const create = () => {
    visible.value = true;
  };

  const close = () => {
    visible.value = false;
  };

  defineExpose({
    create,
    close
  });
</script>

<template>
  <el-dialog
    class="v-restore-access-info-dialog"
    append-to-body
    :title="t('Restore access')"
    :visible="visible"
    width-size="small"
    @close="close"
  >
    <div class="pa-24">
      <div class="mb-16">
        {{ t('If you have lost access to your second-factor device (for example, your phone is lost, stolen, or reset), follow these steps:') }}
      </div>
      <ul class="info-list">
        <li>{{ t('If you used a TOTP authenticator app (like Google Authenticator or Microsoft Authenticator), try restoring the app from a backup, if available.') }}</li>
        <li>{{ t('If you cannot restore the app, contact your account administrator to reset your 2FA settings.') }}</li>
        <li>{{ t('Once 2FA is reset, you can set it up again using your authenticator app.') }}</li>
        <li>{{ t('If you are unsure who your administrator is or do not have one, contact your provider\'s support for assistance.') }}</li>
      </ul>
    </div>

    <template #footer>
      <el-button @click="close">
        {{ t('Close') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.info-list {
  margin-left: 16px;
  padding-left: 8px;

  li {
    margin-bottom: 8px;
    line-height: 1.5;
  }
}
</style>
